export default __webpack_public_path__ + "static/media/icon_settingtype_Flush.008da996.png";